import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { selectUserId, userLogout } from "../../../app/data/appTokensStore"
import { useDeleteUserProfileMutation } from "../../../app/data/userDataSlice/userApi"
import { IoError, ioErrorOf } from "../../../app/data/errors"
import { logout } from "../../../features/authorization_page/AuthorizationSlice"
import useSingIn from "@/hooks/useSingIn"

export const useDeleteAccount = (): {
  deleteAccount: (login: string, password: string) => void
  isLoading: boolean
  error?: IoError
} => {
  const userId = useAppSelector(selectUserId)
  const dispatch = useAppDispatch()
  const handleLogin = useSingIn((error) => console.error(error))


  const [deleteUserProfile, { isLoading, error }] =
    useDeleteUserProfileMutation()


    const deleteAccount = async (login: string, password: string) => {
  try {
    await handleLogin(login, password, true);
    const currentUserId = userId;
    if (!currentUserId) {
      throw new Error("Failed to obtain user ID after login");
    }
    if (window.confirm('Deleting your account is irreversible.  All data and events will be permanently lost. Are you sure you wish to proceed?')) {
      await deleteUserProfile({ userId: currentUserId });
      alert("Your account has been deleted.");
      dispatch(logout());
      dispatch(userLogout());
      window.location.href = '/';
    }
  } catch (error) {
    console.error("Error during account deletion:", error instanceof Error ? error.message : "An unexpected error occurred");
  }
};

  return { deleteAccount, isLoading, error: ioErrorOf(error) }
}
